import React, { Component } from 'react';
import UserComponent from './UserComponent';

class WelcomeScreen extends Component {
    render() {
        return <div className="welcome">
            <p>Welcome to the Community Scoring Survey!</p>
            <p>In this survey, you need to identify whether or not a social media user is a <b>specialist</b> or a <b>generalist</b>.</p>
            <p>You will be presented with a list of online communities someone is a part of. The bar shows what percentage of their activity is in this community.</p>
            <UserComponent communities={"gaming:5;fashion:1"} />
            <p>After reviewing their activity, please rank how generalist or specialist the user is using these buttons.</p>
            <ScoringComponent preview={true} />
            <p>Thank you for your participation!</p>
            <p><span className="btn btn-primary" onClick={this.props.onBegin}>Next Step</span></p>
        </div>;
    }
}

class ScoringComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedScore: null
        };
    }

    render() {
        let preview = this.props.preview;
        let result = (score) => () => this.setState({ selectedScore: score });
        let selected = this.state.selectedScore;

        var submit = <p><span className="btn btn-primary" onClick={() => this.props.onResponse(this.state.selectedScore)}>Submit</span></p>;
        if (selected == null) {
            submit = <p><span className="btn btn-disabled">Submit</span></p>;
        }

        return <div>
            <div className="scoring">
                <div onClick={result(1)} className={selected == 1 ? "active" : null}>Very Generalist</div>
                <div onClick={result(2)} className={selected == 2 ? "active" : null}>Somewhat Generalist</div>
                <div onClick={result(3)} className={selected == 3 ? "active" : null}>Neutral</div>
                <div onClick={result(4)} className={selected == 4 ? "active" : null}>Somewhat Specialist</div>
                <div onClick={result(5)} className={selected == 5 ? "active" : null}>Very Specialist</div>
            </div>
            {preview ? null : submit }
        </div>;
    }
}

class QuestionScreen extends Component {
    render() {
        let question = this.props.question;

        return <div className="question">
            <p>Is this user a generalist or a specialist?</p>
            <UserComponent communities={question.communities} />
            <ScoringComponent onResponse={this.props.onResponse} />
        </div>;
    }
}

export default class UserScoreSingleQuiz {
    renderWelcome(onBegin) {
        return <WelcomeScreen onBegin={onBegin} />;
    }

    loadQuizData(callback) {
        let testQuizData = [
            {
                user_id: "example:2017-1",
                communities: "Vegetarianism:10;veganrecipes:6;vegan:2;veganfitness:2;PlantBasedDiet:1",
            },
            {
                user_id: "example:2017-1",
                communities: "lol:100;apple:101;nintendo:102;h3h3productions:104;JETProgramme:60",
            },
            {
                user_id: "example:2017-1",
                communities: "nfl:30;baseball:7;daddit:1;Colts:17;Cardinals:8",
            },
            {
                user_id: "example:2017-1",
                communities: "AskReddit:1;leagueoflegends:3;Fitness:1;mildlyinteresting:1;pathofexile:41",
            },
            {
                user_id: "example:2017-1",
                communities: "politics:2;The_Donald:431;promos:1;AskThe_Donald:122;electronicmusic:13",
            },
            {
                user_id: "example:2017-1",
                communities: "pics:9;wow:11;funny:9;elderscrollsonline:14;worldofpvp:8",
            },
            {
                user_id: "example:2017-1",
                communities: "canada:13;PersonalFinanceCanada:2;CampingandHiking:1;CanadaPolitics:8;flightsim:45",
            },
            {
                user_id: "example:2017-1",
                communities: "Enough_Sanders_Spam:15;tmobile:1;SwagBucks:4;Louisville:31;NotFoolingAnybody:4",
            },
            {
                user_id: "example:2017-1",
                communities: "personalfinance:3;toronto:29;Hamilton:21;Animals:2;askTO:32",
            },
            {
                user_id: "example:2017-1",
                communities: "StardewValley:10;SWGalaxyOfHeroes:25;sto:29;totalwar:45;ContestOfChampions:13",
            }
        ];

        callback(testQuizData);
    }

    questionComponent() {
        return QuestionScreen;
    }
}


// WEBPACK FOOTER //
// ./src/UserScoreSingleQuiz.js